import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form, Alert } from "react-bootstrap";
import { Information, DollarSquare, CardAdd, Judge, Calendar, Warning2, Add, Trash} from "iconsax-react";
import { Link, useParams, useNavigate } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sports, tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { useMemberships } from "../../../../../hooks/useMemberships";
import DEFAULT_STRUTTURA from "../../../../../images/DEFAULT_STRUTTURA.png";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import AvvisoFatturazione from '../../../../components/Util/AvvisoFatturazione';
import { segnalaMancanti } from '../../../../components/Util/campiMancanti';

import chiediConferma from '../../../../components/Util/chiediConferma';
import { CampoSport, sportDelProdotto, sportDaSalvare } from '../../../../components/Util/sportProdotto';
export const LessonsEdit = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    const { profile: profileData } = useProfile({
        autoFetch: true,
        includeTitles: true
    });
    const { getConfirmedMembers, memberships, loading: membershipsLoading } = useMemberships({ autoFetch: true });

    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED' && profileData?.club?.profileStatus !== 'INACTIVE';

	const [loadingShowed, setLoadingShowed] = useState(false);


    const [modalCentered, setModalCentered] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]


    const dayOptions = [
        { value: 'MONDAY', label: 'Lunedì' },
        { value: 'TUESDAY', label: 'Martedì' },
        { value: 'WEDNESDAY', label: 'Mercoledì' },
        { value: 'THURSDAY', label: 'Giovedì' },
        { value: 'FRIDAY', label: 'Venerdì' },
        { value: 'SATURDAY', label: 'Sabato' },
        { value: 'SUNDAY', label: 'Domenica' }
    ]

    const [enabledSports, setEnabledSports] = useState([])
    const [availableTeachers, setAvailableTeachers] = useState([])
    const [availableFacilities, setAvailableFacilities] = useState([])
    const [filteredTeachers, setFilteredTeachers] = useState([])
    const [filteredFacilities, setFilteredFacilities] = useState([])

    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });
    


    // Titolo della pagina = nome della lezione salvato (non cambia mentre lo si scrive)
    const [nomeSalvato, setNomeSalvato] = useState('');
    usePageTitle(nomeSalvato);

    const [formData, setFormData] = useState({
        id: '',
        name: '', 
        sportTypes: [],
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        newLessonPicture: '',
        lessonPicture: '',
        type: 'CLOSED',
        coachId: '',
        weeklySchedule: []
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const bookingLessons = await apiClient.getBookingLessonById(token, id);
                    setLoadingShowed(false);
                    
                    if(bookingLessons) {
                        setNomeSalvato(bookingLessons.name || '');
                        const elementFormData = {
                            id: bookingLessons.id,
                            name: bookingLessons.name, 
                            sportTypes: sportDelProdotto(bookingLessons),
                            standard_price: bookingLessons.standard_price,
                            member_price: bookingLessons.member_price,
                            federated_price: bookingLessons.federated_price,
                            fitcoin_cashback: bookingLessons.fitcoin_cashback,
                            payable_in_club: bookingLessons.payable_in_club,
                            payable_stripe: bookingLessons.payable_stripe,
                            payable_bank: bookingLessons.payable_bank,
                            vat_rate: bookingLessons.vat_rate,
                            vat_nature: bookingLessons.vat_nature,
                            iva_5_percent: bookingLessons.iva_5_percent,
                            status: bookingLessons.status,
                            description: bookingLessons.description,
                            lessonPicture: bookingLessons.lessonPicture,
                            type: 'CLOSED',
                            coachId: bookingLessons.coachId || '',
                            weeklySchedule: bookingLessons.weeklySchedule || []
                        }
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
        }
    }, [id]);

	useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }
    }, [profileData]);

    useEffect(() => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, []);

    // Load teachers and facilities on page load
    useEffect(() => {
        const fetchTeachersAndFacilities = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    // Wait for memberships to be loaded
                    if (membershipsLoading || !memberships) {
                        console.log('Memberships still loading, waiting...');
                        return;
                    }
                    
                    console.log('Memberships loaded:', memberships.length, 'members');
                    
                    setLoadingShowed(true);
                    const [teachersData, facilitiesData] = await Promise.all([
                        Promise.resolve(getConfirmedMembers('COACH')),
                        apiClient.getVenues(token)
                    ]);
                    setLoadingShowed(false);

                    console.log('Teachers data structure:', teachersData);
                    console.log('Facilities data structure:', facilitiesData);

                    if (teachersData && Array.isArray(teachersData)) {
                        const formattedTeachers = teachersData.map(teacher => ({
                            value: teacher.userId,
                            label: teacher.name,
                            sportType: teacher.sport
                        }));
                        setAvailableTeachers(formattedTeachers);
                    }

                    if (facilitiesData) {
                        // Check if facilitiesData is an array or has a nested structure
                        const facilitiesArray = Array.isArray(facilitiesData) ? facilitiesData : 
                                               (facilitiesData.data && Array.isArray(facilitiesData.data)) ? facilitiesData.data :
                                               (facilitiesData.venues && Array.isArray(facilitiesData.venues)) ? facilitiesData.venues : [];
                        
                        const formattedFacilities = facilitiesArray.map(facility => ({
                            value: facility.id,
                            label: facility.name,
                            sportTypes: sportDelProdotto(facility)
                        }));
                        setAvailableFacilities(formattedFacilities);
                    }
                }
            } catch (error) {
                console.error('Error fetching teachers and facilities:', error);
                setLoadingShowed(false);
            }
        };

        fetchTeachersAndFacilities();
     }, [memberships, membershipsLoading, getConfirmedMembers]);

     // Maestri e impianti di uno degli sport della lezione (anche al primo caricamento)
     useEffect(() => {
         if (formData.sportTypes.length > 0 && availableTeachers.length > 0 && availableFacilities.length > 0) {
             const filteredTeachers = availableTeachers.filter(teacher => 
                 formData.sportTypes.includes(teacher.sportType)
             );
             const filteredFacilities = availableFacilities.filter(facility => 
                 facility.sportTypes.some(sport => formData.sportTypes.includes(sport))
             );
             
             setFilteredTeachers(filteredTeachers);
             setFilteredFacilities(filteredFacilities);
         }
     }, [formData.sportTypes, availableTeachers, availableFacilities]);



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };



    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));

    };

    // Cambiando gli sport: maestri e impianti di quegli sport; il maestro scelto resta solo se ne insegna uno
    const cambiaSport = (elenco) => {
        const filteredTeachers = availableTeachers.filter(teacher => elenco.includes(teacher.sportType));
        const filteredFacilities = availableFacilities.filter(facility => facility.sportTypes.some(sport => elenco.includes(sport)));
        setFilteredTeachers(filteredTeachers);
        setFilteredFacilities(filteredFacilities);
        setFormData(prev => ({
            ...prev,
            sportTypes: elenco,
            coachId: filteredTeachers.some(teacher => teacher.value === prev.coachId) ? prev.coachId : ''
        }));
    };

    const handleSelectChangeBoolean = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || false;
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    // Funzioni per gestire la programmazione settimanale
    const addScheduleItem = () => {
        setFormData({
            ...formData,
            weeklySchedule: [
                ...formData.weeklySchedule,
                {
                    id: Date.now().toString(),
                    dayOfWeek: '',
                    startTime: '',
                    endTime: ''
                }
            ]
        });
    };

    const updateScheduleItem = (index, field, value) => {
        const updatedItems = formData.weeklySchedule.map((item, i) => 
            i === index ? { ...item, [field]: value } : item
        );
        setFormData({ ...formData, weeklySchedule: updatedItems });
    };

    const removeScheduleItem = (index) => {
        const updatedItems = formData.weeklySchedule.filter((_, i) => i !== index);
        setFormData({ ...formData, weeklySchedule: updatedItems });
    };



    const formRefs = useRef({});

    const handleDraftSaveClick = () => {
        if (!formData.name || formData.name.trim() === '') {
            // Il campo e' nella prima scheda: ci si torna e poi lo si segnala
            const segnala = () => segnalaMancanti([{ campo: 'lesson-name', messaggio: 'Manca il nome della lezione' }]);
            if (tabIndex !== 0) {
                setTabIndex(0);
                setTimeout(segnala, 150);
            } else {
                segnala();
            }
            return;
        }
        const form = formRefs.current[tabIndex];
        if (form) {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId;
                formData.status = 'DRAFT';
                saveData();
            }
        }
    };

    // Righe della programmazione settimanale: giorno e orari obbligatori (regola «Dati mancanti»)
    const mancantiProgrammazione = () => {
        const mancanti = [];
        formData.weeklySchedule.forEach((o, i) => {
            if (!o.dayOfWeek) mancanti.push({ campo: `giorno-${i}`, messaggio: 'Manca il giorno' });
            if (!o.startTime) mancanti.push({ campo: `inizio-${i}`, messaggio: "Manca l'ora di inizio" });
            if (!o.endTime) mancanti.push({ campo: `fine-${i}`, messaggio: "Manca l'ora di fine" });
            else if (o.startTime && o.startTime >= o.endTime) mancanti.push({ campo: `fine-${i}`, messaggio: "L'ora di fine deve essere dopo l'inizio" });
        });
        return mancanti;
    };

    const handleSaveClick = (numOfTab, status) => {
        const form = formRefs.current[tabIndex];

        if(numOfTab<6) {
            if (form) {
                const mancanti = [];

                if (numOfTab === 1) {
                    if (!formData.name || formData.name.trim() === '') mancanti.push({ campo: 'lesson-name', messaggio: 'Manca il nome della lezione' });
                    if (formData.sportTypes.length === 0) mancanti.push({ campo: 'lesson-sport', messaggio: 'Manca lo sport della lezione' });
                    if (!formData.coachId) mancanti.push({ campo: 'lesson-coachId', messaggio: 'Manca lo staff tecnico' });
                    if (!formData.newLessonPicture && !formData.lessonPicture) mancanti.push({ campo: 'lesson-photo', messaggio: "Manca l'immagine del prodotto" });
                    if (!formData.description || String(formData.description).trim() === '') mancanti.push({ campo: 'lesson-description', messaggio: 'Manca la descrizione della lezione' });
                }

                if (numOfTab === 2) {
                    const prezzoNonValido = (v) => { const n = parseFloat(v); return isNaN(n) || n <= 0; };
                    if (!(sdiEnabledNoVat || billingNotConfirmed) && prezzoNonValido(formData.standard_price)) mancanti.push({ campo: 'lesson-standard_price', messaggio: 'Il prezzo standard deve essere maggiore di 0' });
                    if (showingTesseratiOptions && prezzoNonValido(formData.federated_price)) mancanti.push({ campo: 'lesson-federated_price', messaggio: 'Il prezzo riservato ai tesserati / soci deve essere maggiore di 0' });
                    const cashback = parseFloat(formData.fitcoin_cashback);
                    if (isNaN(cashback) || cashback < 0) mancanti.push({ campo: 'lesson-fitcoin_cashback', messaggio: 'Il cashback Fitcoin deve essere maggiore o uguale a 0' });
                }

                if (numOfTab === 3) {
                    // Validazione campi payable nel tab Prezzi
                    if (!formData.payable_in_club && !formData.payable_stripe && !formData.payable_bank) {
                        mancanti.push({ campo: 'payable_in_club', messaggio: 'Scegli almeno una forma di pagamento: in struttura, Stripe o bonifico' });
                    }
                }

                if (numOfTab === 4) mancanti.push(...mancantiProgrammazione());

                if (segnalaMancanti(mancanti) > 0) return;

                setTabIndex(numOfTab);
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
            }
        } else {

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId
                formData.status = status
                if(status === 'DRAFT') {
                    saveData();
                } else if(status === 'PURCHASABLE') {
                    saveConfirm();
                }
            }
        }
    };

    const saveConfirm = () => {
		chiediConferma({ titolo: 'Attivare la lezione?', testo: 'La lezione sarà creata e attivata: dopo potrai cambiare solo nome, descrizione, prezzi e forme di pagamento.', conferma: 'Attiva', variante: 'primary' })
		    .then((ok) => { if (ok) saveData(); });
    };

    // L'immagine viaggia come { content, name }: la si invia solo se ne e' stata
    // scelta una nuova, altrimenti si omette il campo (un content null oppure un
    // oggetto gia' incapsulato faceva fallire lo schema con "must be string").
    const preparePicturePayload = (payload, field) => {
        const current = payload[field];
        const content = typeof current === 'string' ? current : current?.content;
        if (content) {
            payload[field] = {
                content: content,
                name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
            };
        } else {
            delete payload[field];
        }
    };

    const saveData = async () => {
        try {
            const payload = { ...formData, ...sportDaSalvare(formData.sportTypes) };

            if(!showingSociOptions) {
                payload.grants_club_membership = false;
                payload.member_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) {
                payload.grants_federated_status = false;
                payload.federated_price = payload.standard_price;
            }

            preparePicturePayload(payload, 'newLessonPicture');

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                const result = await apiClient.updateBookingLesson(token, payload);
                setLoadingShowed(false);

                if(result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/lessons');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    }

    const saveAndActivate = () => {
        const daCorreggere = mancantiProgrammazione();
        if (daCorreggere.length > 0) {
            // I campi sono nel passo «Programmazione»: ci si torna e poi si segnalano
            const passo = tabData.findIndex(t => t.id === 'programmazione');
            if (tabIndex !== passo) {
                setTabIndex(passo);
                setTimeout(() => segnalaMancanti(daCorreggere), 150);
            } else {
                segnalaMancanti(daCorreggere);
            }
            return;
        }
        chiediConferma({ titolo: 'Attivare la lezione?', testo: 'La lezione sarà aggiornata e attivata subito.', conferma: 'Attiva', variante: 'primary' })
            .then((ok) => { if (ok) saveDataAndActivate(); });
    };

    const saveDataAndActivate = async () => {
        try {
            const payload = { ...formData, ...sportDaSalvare(formData.sportTypes) };

            if(!showingSociOptions) {
                payload.grants_club_membership = false;
                payload.member_price = payload.standard_price;
            }
            if(!showingTesseratiOptions) {
                payload.grants_federated_status = false;
                payload.federated_price = payload.standard_price;
            }

            preparePicturePayload(payload, 'newLessonPicture');

            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                payload.clubId = tokenDetails.localId;
                Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
                const apiClient = new MyApiClient();

                setLoadingShowed(true);

                // Prima aggiorna il corso come bozza
                const updateResult = await apiClient.updateBookingLesson(token, payload);
                
                if(updateResult && updateResult.error) {
                    setLoadingShowed(false);
                    setModalTitle("Errore durante l'operazione");
                    setModalText(updateResult.error);
                    setModalShowed(true);
                    return;
                }
                
                // Poi attiva il corso
                const activateResult = await apiClient.changeLessonStatus(token, payload.id, 'PURCHASABLE');
                setLoadingShowed(false);
                
                if(activateResult && activateResult.error) {
                    setModalTitle("Errore durante l'attivazione");
                    setModalText(activateResult.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/lessons');
                }
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in saveDataAndActivate: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                setModalTitle("Errore durante l'operazione");
                setModalText(errorResponseData.detail || 'Errore generico');
                setModalShowed(true);
            } else {
                setModalTitle("Errore durante l'operazione");
                setModalText('Errore generico');
                setModalShowed(true);
            }
        }   
    }

    const goBack = (numOfTab) => {
        if(numOfTab>-1) {
            setTabIndex(numOfTab);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        } else {
            navigate('/struttura/booking/lessons');
        }
	};

	const tabData = [
		{
			id: 'informazioni_generali',
			name: "Informazioni generali",
			icon: <i className="fas fa-info-circle me-2"></i>,
			content: (
                <>
                    <Form ref={el => formRefs.current[0] = el} noValidate>
                        <Card>
                            <Card.Header><h4 className="card-title">Modifica lezione</h4></Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col className="col-xl-6">
                                        <Form.Label>Nome lezione *</Form.Label>
                                        <Form.Control required id="lesson-name" style={{color: '#000000'}} placeholder='Inserisci Nome' type="text" name="name" value={formData.name} onChange={handleChange} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Sport *</Form.Label>
                                        <CampoSport
                                            inputId="lesson-sport"
                                            className=""
                                            valore={formData.sportTypes}
                                            onChange={cambiaSport}
                                            opzioni={enabledSports}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>Staff Tecnico *</Form.Label>
                                        <Select
                                            required
                                            inputId="lesson-coachId"
                                            name="coachId"
                                            value={filteredTeachers.find(option => option.value === formData.coachId) || null}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "coachId")}
                                            options={filteredTeachers}
                                            placeholder="Seleziona prima uno sport..."
                                            isDisabled={formData.sportTypes.length === 0 || filteredTeachers.length === 0}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-12 text-center">
                                        <h4 className="text-center mb-0">Immagine del prodotto *</h4>
                                        <br></br>
                                        <div id="lesson-photo">
                                            {formData.newLessonPicture ? 
                                                <img onClick={() => setModalCentered(true)} src={`data:image/jpeg;base64,${formData.newLessonPicture}`} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                            : formData.lessonPicture ? 
                                                <img onClick={() => setModalCentered(true)} src={formData.lessonPicture} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                            : 
                                                <img onClick={() => setModalCentered(true)} src={DEFAULT_STRUTTURA} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                            }
                                            <br></br>
                                            {(formData.newLessonPicture || formData.lessonPicture) && 
                                                <Button onClick={async () => { if (await chiediConferma({ titolo: 'Rimuovere la foto?', testo: 'La foto sparisce dalla lezione quando salvi.' })) handleRemoveImage(); }} className="btn btn-danger btn-sm mt-2">
                                                    Rimuovi foto
                                                </Button>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-12">
                                        <Form.Label>Descrizione *</Form.Label>
                                        <Form.Control id="lesson-description" rows={10} style={{color: '#000000'}} as="textarea" name="description" value={formData.description} onChange={handleChange} />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                    </Form>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" className="btn btn-dark light" onClick={() => goBack(-1)}>Annulla</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" onClick={() => handleSaveClick(1, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'prezzi',
			name: "Prezzi",
			icon: <DollarSquare size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Header><h4 className="card-title">Imposta i prezzi</h4></Card.Header>
                        <Card.Body>
                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                <Row>
                                    <Col className="col-xl-6 mt-3">
                                        <Form.Label>Prezzo standard *</Form.Label>
                                        <Form.Control required id="lesson-standard_price" disabled={sdiEnabledNoVat || billingNotConfirmed} className={(sdiEnabledNoVat || billingNotConfirmed) ? "mt-2" : ""} style={(sdiEnabledNoVat || billingNotConfirmed) ? {color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal"} : {color: '#000000'}} placeholder='Inserisci il prezzo standard' type="text" name="standard_price" value={formData.standard_price} onChange={handleChange} />
                                    </Col>
                                    <Col className="col-xl-6 mt-3">
                                        <Form.Label>IVA</Form.Label>
                                        <Select
                                            isDisabled={sdiEnabledNoVat || billingNotConfirmed}
                                            name="vat_rate"
                                            value={findVatOption(formData)}
                                            onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                                            options={VAT_OPTIONS}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }}
                                        />
                                    </Col>
                                    {showingTesseratiOptions &&
<Col className="col-xl-6 mt-3">
                                        <Form.Label>Prezzo riservato ai tesserati / soci *</Form.Label>
                                        <Form.Control required id="lesson-federated_price" style={{color: '#000000'}} placeholder='Inserisci il prezzo riservato ai tesserati / soci' type="text" name="federated_price" value={formData.federated_price} onChange={handleChange} />
                                    </Col>
}
                                    <Col className="col-xl-6 mt-3">
                                        <Form.Label>Cashback Fitcoin *</Form.Label>
                                        <Form.Control required id="lesson-fitcoin_cashback" style={{color: '#000000'}} placeholder='Inserisci il numero di fitcoin in cashback' type="text" name="fitcoin_cashback" value={formData.fitcoin_cashback} onChange={handleChange} />
                                    </Col>
                                </Row>

                                {/*showingSociOptions &&
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>Prezzo riservato ai soci</Form.Label>
                                        <Form.Control required style={{color: '#000000'}} placeholder='Inserisci il prezzo riservato ai soci' type="text" name="member_price" value={formData.member_price} onChange={handleChange} />
                                    </Col>
                                </Row> 
                                */}
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(0)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" onClick={() => handleSaveClick(2, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'condizioni_aggiuntive',
			name: "Condizioni aggiuntive",
			icon: <CardAdd size='18' />,
			content: (
				<>

                    <Card>
                        <Card.Header><h4 className="card-title">Condizioni aggiuntive</h4></Card.Header>
                        <Card.Body>
                            <Form ref={el => formRefs.current[2] = el} noValidate>
                                <Row>
                                    <Col className="col-xl-6 mb-3">
                                        <Form.Label>Acquisto pagabile in struttura *</Form.Label>
                                        <Select
                                            required
                                            inputId="payable_in_club"
                                            name="payable_in_club" 
                                            value={optionsBoolean.find(option => option.value === formData.payable_in_club)}
                                            onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_in_club")}
                                            options={optionsBoolean}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }
                                            }
                                        />
                                    </Col>
                                    {paymentMethods.stripe_enabled && (
                                    <Col className="col-xl-6 mb-3">
                                        <Form.Label>Acquisto pagabile su Stripe *</Form.Label>
                                        <Select
                                            required
                                            inputId="payable_stripe"
                                            name="payable_stripe" 
                                            value={optionsBoolean.find(option => option.value === formData.payable_stripe)}
                                            onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_stripe")}
                                            options={optionsBoolean}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }
                                            }
                                        />
                                    </Col>
                                    )}
                                    {paymentMethods.bank_transfer_enabled && (
                                    <Col className="col-xl-6 mb-3">
                                        <Form.Label>Acquisto pagabile con bonifico *</Form.Label>
                                        <Select
                                            required
                                            inputId="payable_bank"
                                            name="payable_bank" 
                                            value={optionsBoolean.find(option => option.value === formData.payable_bank)}
                                            onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_bank")}
                                            options={optionsBoolean}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }
                                            }
                                        />
                                    </Col>
                                    )}
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(1)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        <button type="button" onClick={() => handleSaveClick(3, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'programmazione',
			name: "Programmazione",
			icon: <Calendar size='18' variant='Bulk' />,
			content: (
				<>
					<Form ref={el => formRefs.current[5] = el} noValidate>
						<Card>
							<Card.Header><h4 className="card-title">Programmazione corso</h4></Card.Header>
							<Card.Body>
								<Row>
									<Col className="col-xl-12">
										<div className="d-flex justify-content-between align-items-center mb-3">
											<Form.Label className="mb-0">Programmazione settimanale</Form.Label>
											<Button 
												variant="outline-primary" 
												size="sm" 
												onClick={addScheduleItem}
											>
												<Add size="16" /> Aggiungi orario
											</Button>
										</div>
										{formData.weeklySchedule.map((item, index) => (
											<Row key={item.id} className="mb-3 align-items-end">
												<Col className="col-xl-4">
													<Form.Label htmlFor={`giorno-${index}`}>Giorno *</Form.Label>
													<Select
														inputId={`giorno-${index}`}
														value={dayOptions.find(option => option.value === item.dayOfWeek)}
														onChange={(selectedOption) => updateScheduleItem(index, 'dayOfWeek', selectedOption?.value || '')}
														options={dayOptions}
														placeholder="Seleziona giorno"
													/>
												</Col>
												<Col className="col-xl-3">
													<Form.Label htmlFor={`inizio-${index}`}>Ora inizio *</Form.Label>
													<Form.Control
														id={`inizio-${index}`}
														type="time"
														value={item.startTime}
														onChange={(e) => updateScheduleItem(index, 'startTime', e.target.value)}
													/>
												</Col>
												<Col className="col-xl-3">
													<Form.Label htmlFor={`fine-${index}`}>Ora fine *</Form.Label>
													<Form.Control
														id={`fine-${index}`}
														type="time"
														value={item.endTime}
														onChange={(e) => updateScheduleItem(index, 'endTime', e.target.value)}
													/>
												</Col>
												<Col className="col-xl-2">
													<Button 
														variant="outline-danger" 
														size="sm" 
														onClick={async () => { if (await chiediConferma({ titolo: 'Rimuovere l\'orario?', testo: 'L\'orario sparisce dalla programmazione settimanale.' })) removeScheduleItem(index); }}
													>
														<Trash size="16" />
													</Button>
												</Col>
											</Row>
										))}
									</Col>
								</Row>
							</Card.Body>
						</Card>
						<div className="d-flex justify-content-end gap-4 mt-4">
							<button type="button" onClick={() => goBack(2)} className="btn btn-dark light">Indietro</button>
                            <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                            <button type="button" onClick={() => handleSaveClick(4, 'DRAFT')} className="btn btn-primary">Avanti</button>
						</div>
					</Form>
				</>
			),
		},

		{
			id: 'riepilogo',
			name: "Riepilogo e conferma",
			icon: <Judge size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Header><h4 className="card-title">Riepilogo e conferma</h4></Card.Header>
                        <Card.Body>
                            <Form ref={el => formRefs.current[3] = el} noValidate>
                                <Row>
                                    <Col className="col-xl-6">
                                        <Form.Label>Nome lezione</Form.Label>
                                        <Form.Control disabled 
                                            className="mt-2"
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal", fontSize: "14px"  }} 
                                            placeholder='Inserisci Nome' type="text" name="name" value={formData.name} onChange={handleChange} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Sport</Form.Label>
                                        <CampoSport
                                            isDisabled
                                            className=""
                                            valore={formData.sportTypes}
                                            onChange={() => {}}
                                            opzioni={enabledSports}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>Staff Tecnico</Form.Label>
                                        <Select
                                             isDisabled={true}
                                             name="coachId"
                                             value={availableTeachers.find(option => option.value === formData.coachId) || null}
                                             onChange={(selectedOption) => handleSelectChange(selectedOption, "coachId")}
                                            options={availableTeachers}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }}
                                        />
                                    </Col>

                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-12 text-center">
                                        <h4 className="text-center mb-0">Immagine del prodotto</h4>
                                        <br></br>
                                        {formData.newLessonPicture ? 
                                            <img src={`data:image/jpeg;base64,${formData.newLessonPicture}`} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                        : 
                                            <img src={formData.lessonPicture} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                        }
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-12">
                                        <Form.Label>Descrizione</Form.Label>
                                        <Form.Control disabled 
                                            className="mt-2"
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                            rows={10} as="textarea" name="description" value={formData.description} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6 mt-3">
                                        <Form.Label>Prezzo standard</Form.Label>
                                        <Form.Control disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            placeholder='Inserisci il prezzo standard' type="text" name="standard_price" value={formData.standard_price} onChange={handleChange} />
                                    </Col>
                                    <Col className="col-xl-6 mt-3">
                                        <Form.Label>IVA</Form.Label>
                                        <Select
                                            isDisabled={true}
                                            name="vat_rate"
                                            value={findVatOption(formData)}
                                            onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                                            options={VAT_OPTIONS}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }}
                                        />
                                    </Col>
                                    {showingTesseratiOptions &&
<Col className="col-xl-6 mt-3">
                                        <Form.Label>Prezzo riservato ai tesserati / soci</Form.Label>
                                        <Form.Control disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            placeholder='Inserisci il prezzo riservato ai tesserati / soci' type="text" name="federated_price" value={formData.federated_price} onChange={handleChange} />
                                    </Col>
}
                                    <Col className="col-xl-6 mt-3">
                                        <Form.Label>Cashback Fitcoin</Form.Label>
                                        <Form.Control disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            placeholder='Inserisci il cashback in FitCoin' type="text" name="fitcoin_cashback" value={formData.fitcoin_cashback} onChange={handleChange} />
                                    </Col>
                                    {/*<Col className="col-xl-6">
                                        <Form.Label>Prezzo riservato ai soci</Form.Label>
                                        <Form.Control disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            placeholder='Inserisci il prezzo riservato ai soci' type="text" name="member_price" value={formData.member_price} onChange={handleChange} />
                                    </Col>*/}
                                </Row>

                                <Row className="mt-4">
                                    <Col className="col-xl-6 mb-3">
                                        <Form.Label>Acquisto pagabile in struttura</Form.Label>
                                        <Select
                                            isDisabled={true}
                                            name="payable_in_club" 
                                            value={optionsBoolean.find(option => option.value === formData.payable_in_club)}
                                            onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_in_club")}
                                            options={optionsBoolean}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }
                                            }
                                        />
                                    </Col>
                                    {paymentMethods.stripe_enabled && (
                                    <Col className="col-xl-6 mb-3">
                                        <Form.Label>Acquisto pagabile con Stripe</Form.Label>
                                        <Select
                                            isDisabled={true}
                                            name="payable_stripe" 
                                            value={optionsBoolean.find(option => option.value === formData.payable_stripe)}
                                            onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_stripe")}
                                            options={optionsBoolean}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }
                                            }
                                        />
                                    </Col>
                                    )}
                                    {paymentMethods.bank_transfer_enabled && (
                                    <Col className="col-xl-6 mb-3">
                                        <Form.Label>Acquisto pagabile con bonifico</Form.Label>
                                        <Select
                                            isDisabled={true}
                                            name="payable_bank" 
                                            value={optionsBoolean.find(option => option.value === formData.payable_bank)}
                                            onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_bank")}
                                            options={optionsBoolean}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }}
                                        />
                                    </Col>
                                    )}
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    

                    
                    <Card className="mt-4">
                        <Card.Header>
                            <Card.Title>Programmazione</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-12">
                                    <Form.Label className="mb-3">Programmazione settimanale</Form.Label>
                                    {formData.weeklySchedule && formData.weeklySchedule.length > 0 ? (
                                        formData.weeklySchedule.map((item, index) => (
                                            <Row key={index} className="mb-3">
                                                <Col className="col-xl-4">
                                                    <Form.Label>Giorno</Form.Label>
                                                    <Select
                                                        isDisabled
                                                        value={dayOptions.find(option => option.value === item.dayOfWeek)}
                                                        options={dayOptions}
                                                        placeholder="Seleziona giorno"
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                backgroundColor: '#f2f2f2',
                                                                color: 'rgba(108,117,125,0.6)',
                                                                border: '1px solid #ced4da'
                                                            }),
                                                            singleValue: (provided) => ({
                                                                ...provided,
                                                                color: 'rgba(108,117,125,0.6)'
                                                            })
                                                        }}
                                                    />
                                                </Col>
                                                <Col className="col-xl-4">
                                                    <Form.Label>Ora inizio</Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        className="mt-2"
                                                        style={{
                                                            color: 'rgba(108,117,125,0.6)', 
                                                            backgroundColor: '#f2f2f2', 
                                                            paddingLeft: "15px", 
                                                            fontWeight: "normal"
                                                        }}
                                                        type="time"
                                                        value={item.startTime}
                                                    />
                                                </Col>
                                                <Col className="col-xl-4">
                                                    <Form.Label>Ora fine</Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        className="mt-2"
                                                        style={{
                                                            color: 'rgba(108,117,125,0.6)', 
                                                            backgroundColor: '#f2f2f2', 
                                                            paddingLeft: "15px", 
                                                            fontWeight: "normal"
                                                        }}
                                                        type="time"
                                                        value={item.endTime}
                                                    />
                                                </Col>
                                            </Row>
                                        ))
                                    ) : (
                                        <p style={{color: 'rgba(108,117,125,0.6)', fontStyle: 'italic'}}>Nessuna programmazione settimanale configurata</p>
                                    )}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(4)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleDraftSaveClick()} className="btn btn-secondary">Salva come bozza</button>
                        {!billingNotConfirmed && <button type="button" onClick={() => saveAndActivate()} className="btn btn-primary">Salva e attiva</button>}
                    </div>
                </>
			),
		}
	];

    function handleRemoveImage() {
        setFormData({
            ...formData,
            newLessonPicture: null,
            lessonPicture: null
        });
    }

    // Stato accanto al titolo: la lezione qui è una bozza (si attiva con «Salva e attiva»)
    useStatoNelTitolo({ visibile: formData?.status === 'DRAFT', bozza: true });

	return (
		<>
			<ProductImageUploader
                show={modalCentered}
                onClose={() => setModalCentered(false)}
                onSave={(base64String) => {
                    setModalCentered(false);
                    setFormData({
                        ...formData,
                        newLessonPicture: base64String
                    });
                }}
                titolo="Immagine della lezione"
            />


			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			{billingNotConfirmed && (
				<AvvisoFatturazione />
			)}

			<div className="custom-tab-1">
                <Tab.Container activeKey={tabData[tabIndex]?.id.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link onClick={(e) => e.preventDefault()} eventKey={data.id.toLowerCase()} style={{ cursor: 'default', pointerEvents: 'none' }}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-12">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
					</Row>
				</Tab.Container>
			</div>
		</>
	)
}
export default LessonsEdit;